"use client"

import { useState, useEffect } from "react"
import { RecentViewsBlock } from "@/components/blocks/recent-views"
import { getRecentlyViewed } from "@/lib/recommendations"

/**
 * Recently Viewed block for blog tag pages.
 *
 * FRIDGE-1501 F7: the Bestsellers block that sat above it is retired. It
 * rendered nothing (its read returned nothing on every page), and Fridge.com
 * has no sales data to rank by.
 */
export function TagBottomBlocks() {
  const [recentViews, setRecentViews] = useState<any[]>([])

  useEffect(() => {
    getRecentlyViewed(6).then(setRecentViews, () => setRecentViews([]))
  }, [])

  return (
    <div className="mt-3 space-y-3 px-2 sm:px-0">
      <RecentViewsBlock products={recentViews} />
    </div>
  )
}
